import { FiHighlightService } from '@fi-shared/fi-highlight/fi-highlight.service';
import { ChangeDetectionStrategy, inject, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NewsFeedModel } from '../news-feed.model';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { NewsFeedService } from '../news-feed.service';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { INewsFeedModel } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-news-feed-item-single-view',
    templateUrl: './news-feed-item-single-view.component.html',
    styleUrls: ['./news-feed-item-single-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-item-single-view' },
    standalone: false,
})
export class NewsFeedItemSingleViewComponent implements OnInit, OnDestroy {
    @Input() newsFeedItem: INewsFeedModel;
    @Input() forum;
    @Input() highlightText: string;
    @Input() focusNewComment: boolean;
    @Input() commentId: number;

    protected newsFeedModel: NewsFeedModel;
    private HasForumEditAccess: boolean = false;

    private accessToApplicationTypeService = inject(AccessToApplicationTypeService);
    private newsFeedService = inject(NewsFeedService);
    private mobileAppHelperService = inject(FiMobileAppHelperService);
    private stateService = inject(FiStateService);
    private highlightService = inject(FiHighlightService);
    private userDataService = inject(FiUserDataService);
    private fiFormatDateService = inject(FiFormatDateService);

    public ngOnInit(): void {
        if (this.highlightText) {
            this.highlightService.setHighlightText(this.highlightText);
        }

        this.newsFeedModel = new NewsFeedModel(
            this.newsFeedItem,
            this.userDataService.userData.PreferredContentLanguage,
            this.fiFormatDateService,
        );

        this.HasForumEditAccess =
            this.forum &&
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.ForumAdmin,
                AccessRightType.Read,
            ) &&
            this.forum.AccessRightFilterCollection.HasEditAccess;

        // get delete access data
        //this.newsFeedService.updateDeleteAccess([this.newsFeedModel]);
    }

    protected getHighlightCommentId(): void {
        return this.stateService.params.commentId;
    }

    protected deleteNewsFeedItem(itemToDelete: NewsFeedModel): void {
        this.newsFeedService.deleteNewsFeedItem(itemToDelete).then(() => {
            this.mobileAppHelperService.reloadPriorityFeed();
            window.history.back();
        });
    }

    public ngOnDestroy(): void {
        this.newsFeedService.ShowComment = false;
    }
}
